<template>
  <div>
    <div class="card shadow">
      <div class="card-header bg-transparent">
        <div>
          <h3 class="mb-0">
            {{ $tc('message.Addcomptable', 1) }}
          </h3>
        </div>
      </div>

      <div class=" " :class="[ mobileView ? 'pt-3': 'card-body']">
        <b-form >
          <div class=" " :class="[ mobileView ? '' : 'container']">


            <b-row>
              <b-col sm="12">
                <span  class="obligatoire">*</span>
                <b-form-group
                    id="institution-group"
                    :label="$tc('message.institutions',1)"
                    label-for="institution"
                >
                  <select id="institution" v-model="$v.form.etablissement.$model"
                          @change="clearErrorField('etablissement_id')"
                          class="form-control is-invalid retirerBordure"
                  >
                    <option data-placeholder="true"></option>
                    <option v-for="item in mInstitutions" :key="item.value" :value="item.value">
                      {{ item.text }}
                    </option>
                  </select>
                  <div class="invalid-feedback" v-if="$v.form.etablissement.$error">
                    {{ $t('message.requiredField') }}
                  </div>
                  <span v-if="errorshasField('etablissement_id')" style="color:red">
                                    {{getErrorsField('etablissement_id')}}
                                    </span>
                </b-form-group>

              </b-col>

<!--              <b-col sm="12">-->
<!--                <span  class="obligatoire">*</span>-->
<!--                <b-form-group-->
<!--                    id="praticiens-group"-->
<!--                    :label="$t('message.nomPartenaire')"-->
<!--                    label-for="institution"-->
<!--                >-->
<!--                  <select id="nomPartenaire" v-model="$v.form.user_id.$model"-->
<!--                          @change="clearErrorField('user_id')"-->
<!--                          class="form-control is-invalid retirerBordure"-->
<!--                  >-->
<!--                    <option data-placeholder="true"></option>-->

<!--                    <option v-for="(item,index) in mUsers" :key="index" :value="item.value">-->
<!--                      {{ item.text }}-->
<!--                    </option>-->
<!--                  </select>-->
<!--                  <div class="invalid-feedback" v-if="$v.form.user_id.$error">-->
<!--                    {{ $t('message.requiredField') }}-->
<!--                  </div>-->
<!--                  <span v-if="errorshasField('user_id')" style="color:red">-->
<!--                                    {{getErrorsField('user_id')}}-->
<!--                                    </span>-->
<!--                </b-form-group>-->

<!--              </b-col>-->
            </b-row>
<!--            <b-form-checkbox class="mt-3 mb-3 ml-3" v-model="checked" name="check-button" switch>-->
<!--              {{$t('message.userNotFound')}} <b>{{ checked ? $t('message.yes') : $t('message.no')}}</b>-->
<!--            </b-form-checkbox>-->
            <b-row v-if="checked">
              <b-col sm="6">
                <span  class="obligatoire">*</span>
                <b-form-group
                    id="nom-group"
                    :label="$t('message.lastName')"
                    label-for="nom"
                    description=""

                >

                  <b-form-input
                      id="nom"
                      v-model="$v.form.nom.$model"
                      :state="$v.form.nom.$dirty ? !(errorshasField('nom') || $v.form.nom.$error) : null"
                      type="text"
                      placeholder=""
                      @focus="clearErrorField('nom')"
                  ></b-form-input>

                  <b-form-invalid-feedback  v-if="!$v.form.nom.isNotUser">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-else-if="errorshasField('nom')">
                    {{ getErrorsField('nom') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="6">

                <b-form-group
                    id="prenom-group"
                    :label="$t('message.firstName')"
                    label-for="prenom"
                >
                  <b-form-input
                      id="prenom"
                      v-model="$v.form.prenom.$model"
                      type="text"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <span  class="obligatoire">*</span>

                <b-form-group
                    id="indicatif-group"
                    :label="$t('message.indicatif')"
                    label-for="indicatif"
                >
                  <b-form-input
                      id="indicatif"
                      v-model="$v.form.indicatif.$model"
                      :state="$v.form.indicatif.$dirty ? !($v.form.indicatif.$error) : null"
                      required
                      placeholder=""
                  ></b-form-input>

                  <b-form-invalid-feedback v-if="!$v.form.indicatif.isNotUser">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>
                  <b-form-invalid-feedback v-if="!$v.form.indicatif.numeric">
                    {{ $t('message.integer', { n: 3 }) }}
                  </b-form-invalid-feedback>
                  <b-form-invalid-feedback v-if="!$v.form.indicatif.maxLength">
                    {{ $t('message.maxCharacters', { n: 3 }) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="9">
                <b-form-group
                    id="numero-group"
                    :label="$t('message.phoneNumber')"
                    label-for="numero"
                >
                  <b-form-input
                      id="numero"
                      v-model="$v.form.telephone.$model"
                      :state="$v.form.telephone.$dirty ? !(errorshasField('telephone') || $v.form.telephone.$error) : null"

                      placeholder=""
                      @focus="clearErrorField('telephone')"
                  ></b-form-input>

                  <!--                                    <b-form-invalid-feedback v-if="!$v.form.numero.required">-->
                  <!--                                        {{ $t('message.requiredField') }}-->
                  <!--                                    </b-form-invalid-feedback>-->

                  <b-form-invalid-feedback v-if="!$v.form.telephone.integer">
                    {{ $t('message.integer', { n: 9 }) }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-if="!$v.form.telephone.minLength">
                    {{ $t('message.minCharacters', { n: 9 }) }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-if="errorshasField('telephone')">
                    {{ getErrorsField('telephone') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <span  class="obligatoire">*</span>

                <b-form-group
                    id="email-group"
                    :label="$t('message.email')"
                    label-for="email"
                >
                  <b-form-input
                      id="email"
                      v-model="$v.form.email.$model"
                      :state="$v.form.email.$dirty ? !(errorshasField('email') || $v.form.email.$error) : null"
                      type="email"
                      placeholder=""
                      @focus="clearErrorField('email')"
                  ></b-form-input>

                  <b-form-invalid-feedback v-if="!$v.form.email.isNotUser">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-else-if="!$v.form.email.email">
                    {{ $t('message.emailNotValid') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-else-if="errorshasField('email')">
                    {{ getErrorsField('email') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-form-checkbox class="mt-5  ml-3" v-model="form.sexe" name="check-button" switch>
                {{$t('message.gender')}} <b>{{ form.sexe ? $t('message.male') : $t('message.female')}}</b>
              </b-form-checkbox>
            </b-row>
            <b-row class="justify-content-center">
              <b-button @click="onSubmit" variant="primary" v-if="can">
                {{ $t('message.save') }}
              </b-button>
            </b-row>
          </div>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { required, email, minLength,integer,numeric,maxLength} from 'vuelidate/lib/validators';
import _ from 'lodash';
import SlimSelect from 'slim-select';
export default {
  name: "AddAccountant",
  filters: {
    capitalize: function (value) {
      if (!value) return '';
      value = value.toString().toUpperCase();
      return value;
    }
  },
  computed: {
    ...mapGetters(["institutions","userInstitutions", "professions", "specialties", "countries", "errors", 'hasAdminRole',
      'hasGestionnaireRole','hasMedecinControleRole','comptables','hasAssistante']),

    can: function () {
      return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.hasAssistante;
    },

    mInstitutions: function () {
      let iArray = [];

      _.forOwn(this.userInstitutions, function (value) {
        iArray.push({text: value.name, value: value.id});
      });
      return iArray;
    },

    mUsers:function(){
      let uArray = [];

      if (this.form.etablissement != null && this.form.etablissement != ''){
        uArray = [];
        let self = this;
        let etablissement = _.find(self.userInstitutions,function (institution) {
          return institution.id == self.form.etablissement;
        })

        if (!_.isUndefined(etablissement)){
          let praticiens = etablissement.praticiens;

          _.forEach(praticiens, function (praticien) {
            if (praticien.user != null) {
              let prenom = praticien.user.prenom != null ? praticien.user.prenom : '';
              prenom = prenom.toLowerCase();
              let nomComplet = (praticien.user.nom).toUpperCase() + " " + prenom.charAt(0).toUpperCase() + prenom.substring(1);

              uArray.push({text: nomComplet, value: praticien.user.id});
            }
          })
        }
        _.forEach(self.comptables, function (comptable){
          let prenom = comptable.user.prenom != null ? comptable.user.prenom : '';
          prenom = prenom.toLowerCase();
          let nomComplet = (comptable.user.nom).toUpperCase() + " " + prenom.charAt(0).toUpperCase() + prenom.substring(1);

          uArray.push({text: nomComplet, value: comptable.user.id});
        })
      }
      return uArray;
    }
  },
  data() {
    return {
      praticienSelect:Object,
      checked: true,
      mobileView: true,
      form: {
        nom: '',
        sexe:true,
        prenom: '',
        etablissement: [],
        indicatif:'',
        telephone:'',
        email:'',
        user_id:''
      }
    }
  },
  watch:{
    checked:function (val) {
      if (val == true){
        this.form.user_id = '';
        this.praticienSelect.disable();
      }else{
        this.praticienSelect.enable();
      }
    }
  },
  methods:{
    handleView() {
                this.mobileView = window.innerWidth <= 990;
            },
    getInstitutions: function() {
      let args = {};
      let errorMessages = {
        generic: this.$i18n.t('message.genericError'),
        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
      };

      this.$store.dispatch('getInstitutions', { args, errorMessages });
    },

    getUserInstitutions() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getUserInstitutions', { args : args });
    },

    getComptables: function() {
      let args = {};
      let errorMessages = {
        generic: this.$i18n.t('message.genericError'),
        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
      };

      this.$store.dispatch('getComptables', { args, errorMessages });
    },

    getErrorsField(field){
      if (this.errorshasField(field)){
        return this.errors[field][0];
      }else{
        return  '';
      }
    },

    onSubmit(evt){
      evt.preventDefault();

      this.$v.$touch();

      if(!this.$v.$invalid) {
        let args = {};

        args.etablissement_id = this.form.etablissement;
        if (this.checked){
          args.email = this.form.email;
          args.nom = this.form.nom;
          args.prenom = this.form.prenom;
          args.sexe = this.form.sexe ? 'M' :'Mme';
          args.telephone = this.form.indicatif + this.form.telephone;
        }else{
          args.user_id = this.form.user_id;
        }
        let successMessage = this.$i18n.t('message.comptableCreated');
        let errorMessages = {
          generic: this.$i18n.t('message.genericError'),
          error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
        };

        this.$store.dispatch('createComptable', { args, errorMessages, successMessage })

      }
    },

    errorshasField(field){
      return this.errors ? this.errors.hasOwnProperty(field) : false;
    },

    clearErrorField(field){
      this.$store.dispatch('clearErrorField', { field });

      this.getErrorsField(field);
    },

    isUser:function () {
      return !(this.checked == false && this.form.user_id == '');
    },

    isNotName:function(){
      return  !(this.checked == true && this.form.nom =='');
    },

    isNotEmail:function(){
      return  !(this.checked == true && this.form.email =='');
    },

    isNotTelephone:function(){
      return  !(this.checked == true && this.form.telephone =='');
    },

    isNotIndicatif:function(){
      return  !(this.checked == true && this.form.indicatif =='');
    }
  },
  validations() {
    return {
      form: {
        user_id:{isUser:this.isUser},

        nom: {
          isNotName: this.isNotName
        },

        prenom: {
        },

        etablissement: {
          required
        },

        telephone: {
          isNotTelephone: this.isNotTelephone,
          minLength: minLength(9),
          numeric
        },

        indicatif: {
          isNotIndicatif:this.isNotIndicatif,
          maxLength: maxLength(3),
          numeric
        },

        email: {
          isNotEmail:this.isNotEmail,
          email
        },
      }
    }
  },
  created() {
              this.handleView();
              window.addEventListener('resize', this.handleView);
          },
  mounted() {

    // Retrieve list of institutions
    this.getInstitutions();

    this.getUserInstitutions();

    // Retrieve list of accountant/etablissement
    this.getComptables();


    new SlimSelect({
      select: '#institution',
      placeholder: 'Select institution',
    });

    var praticiens = new SlimSelect({
      select: '#nomPartenaire',
      placeholder: 'Select user',
    });

    this.praticienSelect = praticiens;
  }

}
</script>

<style scoped>

</style>